import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import errorImage from '../../../../assets/cashOutError.png'
import styles from './styles.scss'

const ValidationsError = ({ isPurchase }) => (
  <div className={styles.container}>
    <img className="mb-32" src={errorImage} alt="validations-error" />
    <Font type="medium" weight="bold" className="mb-8">
      {isPurchase
        ? 'Down payment should be lower than purchase price.'
        : 'Your loan amount cannot be greater than your home’s value'}
    </Font>
    <Font type="bodySmall" color="lighter">
      {isPurchase
        ? 'Please update your down payment and purchase price to see rates.'
        : 'Please update the loan amount and home value to see loan offers.'}
    </Font>
  </div>
)
ValidationsError.propTypes = {
  isPurchase: PropTypes.bool.isRequired,
}
export default ValidationsError
